import React, { useEffect, useState } from "react";
import { database, ref, push, onValue, update, set, remove } from "./firebase";
import { useNavigate } from "react-router-dom"; // ✅ Import navigation
import "./BillingSystem.css";
import BossNavigation from "./BossNavigation";
import Navigation from "./Navigation";


export default function ScrapStockPage({ role }) {
  const [scrapItems, setScrapItems] = useState([]);
  const [newItemName, setNewItemName] = useState("");
  const [history, setHistory] = useState([]);
  const navigate = useNavigate(); // ✅ Init navigate

  useEffect(() => {
    if (role !== "stock manager" && role !== "production"&&role !== "boss") return;


    const stockRef = ref(database, "scrapStock");
    const historyRef = ref(database, "scrapStockHistory");

    onValue(stockRef, (snapshot) => {
      const data = snapshot.val() || {};
      const formatted = Object.entries(data).map(([id, value]) => ({
        id,
        name: value.name,
        quantity: value.quantity || 0
      }));
      setScrapItems(formatted);
    });

    onValue(historyRef, (snapshot) => {
      const data = snapshot.val() || {};
      const list = Object.entries(data)
        .map(([id, value]) => ({
          id,
          ...value
        }))
        .sort((a, b) => new Date(b.date) - new Date(a.date));
      setHistory(list);
    });
  }, [role]);

  const handleAddItem = async () => {
    if (!newItemName.trim()) return alert("Enter item name");
    const newRef = push(ref(database, "scrapStock"));
    await set(newRef, {
      name: newItemName.trim(),
      quantity: 0
    });
    setNewItemName("");
  };

  const handleDeleteItem = async (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      await remove(ref(database, `scrapStock/${id}`));
    }
  };

  const handleEditItem = async (id, currentName) => {
    const newName = prompt("Enter new scrap item name:", currentName);
    if (newName && newName.trim()) {
      await update(ref(database, `scrapStock/${id}`), {
        name: newName.trim()
      });
    }
  };

  const logHistory = async (itemName, type, quantity) => {
    const historyRef = push(ref(database, "scrapStockHistory"));
    await set(historyRef, {
      item: itemName,
      type,
      quantity,
      date: new Date().toISOString()
    });
  };

  const handleAddQuantity = async (id) => {
    const addQty = parseFloat(prompt("Enter KG to add:"));
    if (isNaN(addQty) || addQty <= 0) return;
    const item = scrapItems.find(p => p.id === id);
    await update(ref(database, `scrapStock/${id}`), {
      quantity: item.quantity + addQty
    });
    await logHistory(item.name, "Added", addQty);
  };

  const handleEditHistoryQuantity = async (entry) => {
    const newQty = parseFloat(prompt("Enter new KG:", entry.quantity));
    if (isNaN(newQty) || newQty <= 0) return;

    const difference = entry.type === "Added"
      ? newQty - entry.quantity
      : entry.quantity - newQty;

    const item = scrapItems.find(p => p.name === entry.item);
    if (!item) return alert("Item not found.");

    const updatedQty = item.quantity + (entry.type === "Added" ? difference : -difference);
    if (updatedQty < 0) return alert("Resulting stock would be negative.");

    await update(ref(database, `scrapStock/${item.id}`), {
      quantity: updatedQty
    });

    await update(ref(database, `scrapStockHistory/${entry.id}`), {
      quantity: newQty
    });
  };

  const handleDeleteHistoryEntry = async (entry) => {
    if (!window.confirm("Delete this history entry?")) return;

    const item = scrapItems.find(p => p.name === entry.item);
    if (!item) return alert("Item not found.");

    const newQty =
      entry.type === "Added"
        ? item.quantity - entry.quantity
        : item.quantity + entry.quantity;

    if (newQty < 0) return alert("Cannot delete, stock would go negative.");

    await update(ref(database, `scrapStock/${item.id}`), {
      quantity: newQty
    });

    await remove(ref(database, `scrapStockHistory/${entry.id}`));
  };

  if (role !== "stock manager" && role !== "production"&& role !== "boss" ) {
  return <p>Access denied. This page is for Stock Managers and Production only.</p>;
}

  return (
    <div className="container">
      <h2>Scrap Stock Management (KG)</h2>
      {role === "boss" && <BossNavigation />}
      <Navigation role={role} />


      <div className="section">
        <input
          placeholder="New Scrap Item Name"
          value={newItemName}
          onChange={(e) => setNewItemName(e.target.value)}
        />
        <button onClick={handleAddItem}>Add Scrap Item</button>
      </div>

      <div className="section">
        <h4>Current Scrap Stock</h4>
        <table className="stock-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Quantity (KG)</th>
              <th>Add</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {scrapItems.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.quantity}</td>
                <td><button onClick={() => handleAddQuantity(item.id)}>+ Add</button></td>
                <td><button onClick={() => handleEditItem(item.id, item.name)}>✏️</button></td>
                <td><button onClick={() => handleDeleteItem(item.id)}>🗑 Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="section">
        <h4>Scrap History</h4>
        <table className="stock-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Item</th>
              <th>Type</th>
              <th>Quantity (KG)</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {history.map((entry, index) => (
              <tr key={index}>
                <td>{new Date(entry.date).toLocaleString()}</td>
                <td>{entry.item}</td>
                <td>{entry.type}</td>
                <td>{entry.quantity}</td>
                <td><button onClick={() => handleEditHistoryQuantity(entry)}>✏️</button></td>
                <td><button onClick={() => handleDeleteHistoryEntry(entry)}>🗑</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
